<template>    
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span >
              {{ $t('project.form.shareholders.title') }}   

              <div class="float-right" v-if="mailToConvention != null && mailToConvention != ''" >
                <a :href="'mailto:'+ mailToConvention" :title="$t('project.investment.form.history.conventionMail')" ><span class="fa fa-envelope fa-lg"></span></a>
              </div>
          </span>
        </div>
        <div class="card-body">
          
          <div v-if="shareholders == null || shareholders.length == 0">
            {{ $t("form.aucun_donne") }}
          </div>

          <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th class=drop-down-filter>{{ $t('project.investment.form.history.typePerson') }}</th>
                <th>{{ $t('project.investment.form.history.person') }}</th>
                <th class=drop-down-filter>{{ $t('project.investment.form.history.status') }}</th>
                <th class=drop-down-filter>{{ $t('project.investment.form.history.lead') }}</th>
                <th class=drop-down-filter>{{ $t('project.investment.form.history.convention') }}</th>
                <th>{{ $t('entrepreneur.form.email') }}</th>
                <th>{{ $t('entrepreneur.form.cellphone') }}</th>
                <th>{{ $t('entrepreneur.form.phone') }}</th>
                <th>{{ $t('entrepreneur.form.officePhone') }}</th>
                <th class="no-sort no-filter">{{ $t('project.investment.form.history.invested') }}</th>
                <th class="no-sort no-filter">{{ $t('project.investment.form.history.exited') }}</th>
                <th class="no-sort no-filter"></th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th class=drop-down-filter>{{ $t('project.investment.form.history.typePerson') }}</th>
                <th>{{ $t('project.investment.form.history.person') }}</th>
                <th class=drop-down-filter>{{ $t('project.investment.form.history.status') }}</th>
                <th class=drop-down-filter>{{ $t('project.investment.form.history.lead') }}</th>
                <th class=drop-down-filter>{{ $t('project.investment.form.history.convention') }}</th>
                <th>{{ $t('entrepreneur.form.email') }}</th>
                <th>{{ $t('entrepreneur.form.cellphone') }}</th>
                <th>{{ $t('entrepreneur.form.phone') }}</th>
                <th>{{ $t('entrepreneur.form.officePhone') }}</th>
                <th class="no-sort no-filter">{{ $t('project.investment.form.history.invested') }}</th>
                <th class="no-sort no-filter">{{ $t('project.investment.form.history.exited') }}</th>
                <th class="no-sort no-filter"></th>
              </tr>
            </tfoot>
            <tbody>
              <tr v-for="item in shareholders">
                <td>{{ item.typePerson }} </td>
                <td>{{ item.name }} </td>
                <td>{{ item.status | formatBoolean }} </td>
                <td>{{ item.lead | formatBoolean }} </td>
                <td>{{ item.conventionVoteAq | formatBoolean }} </td>
                <td>{{ item.email }} </td>
                <td>{{ item.cellphone }} </td>
                <td>{{ item.phone != null ? item.phone : '' }} </td>
                <td>{{ item.officePhone + (item.officePhoneExtension != null && item.officePhoneExtension != "" ? '#' + item.officePhoneExtension : '') }}</td>
                <th class="no-sort no-filter text-success">{{ item.value }}</th>
                <th class="no-sort no-filter text-danger">{{ item.exitValue }}</th>
                <td class="no-sort no-filter" align=center><a v-if="item.email != null && item.email != ''" :href="'mailto:' + item.email"><i class="fa fa-envelope"></i></a></td>
              </tr>
            </tbody>
          </table>
  
        </div>
      </div>
    </div>
  </div>
        
</template>

<script>
  import {
    CompanyServiceClient,
    CompanyPersonServiceClient,
    CompanyPersonDto,
    MemberServiceClient,
    UserServiceClient,
    EntrepreneurServiceClient,
    PartnerServiceClient,
    PartnerDto,
    MemberDto,
    UserDto,
    EntrepreneurDto,
  } from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import SearchMixin from '../../shared/Mixin/SearchMixin'

  export default {
    name: 'Shareholder',
    mixins: [CrudMixin, SearchMixin],
    props: {
      investments: {},
      exits: {},
    },
    data() {
      return {
        isLoading: false,
        shareholders: [],
        partners: [],
      }
    },
    watch: {
      investments: function(newValue, oldValue) {
        if (newValue != null && newValue.length > 0 && this.shareholders.length == 0) {
          let flatExit = []
          if (this.exits != null && this.exits.length > 0) {
            flatExit = _.chain(this.exits)
              .flatMap(f => f.exitPerson)
              .map(m => ({
                partner: m.partner,
                member: m.member,
                value: m.value,
              }))
              .value()
          }

          this.shareholders = _.chain(this.investments)
            .flatMap(f => f.investmentValues)
            .groupBy(g => (g.partner != null ? g.partner.name : g.member.familyName + ' ' + g.member.name))
            .map((value, key) => ({
              typePerson:
                value[0].member != undefined && value[0].memberType !== 3
                  ? this.$t('project.investment.form.history.member')
                  : value[0].member != undefined && value[0].memberType === 3
                    ? this.$t('project.investment.form.history.memberJr')
                    : this.$t('project.investment.form.history.partner'),
              name: key,
              lead: _.find(value, ff => ff.lead) != null,
              conventionVoteAq: _.find(value, ff => ff.conventionVoteAq) != null,
              email: value[0].member != null ? value[0].member.email : this.getPartnerEmail(value[0].partnerId),
              phone: value[0].member != null ? value[0].member.phone : this.getPartnerPhone(value[0].partnerId),
              cellphone: value[0].member != null ? value[0].member.cellphone : '',
              officePhone: value[0].member != null ? value[0].member.officePhone : '',
              officePhoneExtension: value[0].member != null ? value[0].member.officePhoneExtension : '',
              status: value[0].member != null ? value[0].memberStatus : true, // value[0].partner.status == 2
              value: _.sumBy(value, 'value'),
              exitValue: _.chain(flatExit)
                .filter(
                  f =>
                    (f.member != null && value[0].member != null && value[0].member.id == f.member.id) ||
                    (f.partner != null && value[0].partner != null && value[0].partner.id == f.partner.id)
                )
                .sumBy(s => s.value)
                .value(),
            }))
            .value()
  
          this.showDataTable({}, this)
        }
      },
    },
    computed: {
      mailToConvention: function() {
        if (this.shareholders != null && this.shareholders.length > 0) {
          return _.chain(this.shareholders)
            .filter(f => f.conventionVoteAq)
            .map(m => m.email)
            .value()
            .join()
        }
        return ''
      },
    },
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    methods: {
      fetchData: function() {
        this.chargerPartners()
      },
      chargerPartners: function() {
        let partnerService = ServiceFactory.create(PartnerServiceClient)
        let self = this

        partnerService
          .getAll('', 0, 10000)
          .then(res => {
            self.partners = res.items
          })
          .catch(err => {
            console.log(err)
          })
      },
      getPartnerEmail: function(partnerId) {
        let partner = _.find(this.partners, x => x.id == partnerId)
        if (partner.partnerContact == null || partner.partnerContact.length == 0) return ''

        return partner.partnerContact[0].email
      },
      getPartnerPhone: function(partnerId) {
        let partner = _.find(this.partners, x => x.id == partnerId)
        if (partner.partnerContact == null || partner.partnerContact.length == 0) return ''

        return partner.partnerContact[0].phone
      },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/projects/Shareholder.vue